export enum SearchParamKeys {
  SHOW_SUCCESS = 'showSuccess',
  ORG_ID = 'orgId',
  LOGIN_INFO = 'loginInfo',
  LOGIN_ERROR = 'loginError',
  LOGIN_REDIRECT_URL = 'redirectUrl',
  TOKEN = 'token',
  LANGUAGE = 'language',
  EMAIL_INPUT = 'email_input',
  MAIL = 'mail',
  UTM_MEDIUM = 'utm_medium',
  UTM_SOURCE = 'utm_source',
  UTM_CAMPAIGN = 'utm_campaign',
  UTM_ADGROUP = 'utm_adgroup',
  UTM_TERM = 'utm_term',
  DEVICE = 'device',
  MATCHTYPE = 'matchtype',
  FBCLID = 'fbclid',
  LEADSOURCE = 'leadsource',
  TAB = 'tab[]',
  APPLICANT_ID = 'applicantId',
}
